import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLang } from '@/lib/LanguageContext';

// Premium cyan message that materializes where a long press ended.
export default function CircuitNote({ x, y, onDone }) {
  const { language } = useLang();
  const text = language === 'es' ? 'Construyamos el proyecto de tus sueños' : "Let's build your dream project";
  useEffect(() => { const t = setTimeout(onDone, 4200); return () => clearTimeout(t); }, [onDone]);
  const left = Math.min(Math.max(x, 180), window.innerWidth - 180);
  const top = Math.min(Math.max(y, 60), window.innerHeight - 60);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9, filter: 'blur(8px)' }}
      animate={{ opacity: [0, 1, 1, 0], scale: [0.9, 1, 1, 1.03], filter: ['blur(8px)', 'blur(0px)', 'blur(0px)', 'blur(6px)'] }}
      transition={{ duration: 4, times: [0, 0.18, 0.8, 1], ease: 'easeOut' }}
      style={{ left, top, x: '-50%', y: '-50%' }}
      className="fixed pointer-events-none z-[9999] text-center select-none">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-primary to-transparent mb-3" />
      <p className="font-inter font-black uppercase tracking-[0.25em] text-sm md:text-lg whitespace-nowrap text-transparent bg-clip-text bg-gradient-to-r from-primary via-foreground to-primary drop-shadow-[0_0_12px_hsl(var(--primary)/0.7)]">
        {text}
      </p>
      <div className="h-px w-full bg-gradient-to-r from-transparent via-primary to-transparent mt-3" />
    </motion.div>
  );
}